import React from 'react';
import useAxiosInterceptor from 'hooks/useApiInterceptorsResponse';

/*
 * Higher-Order Component (HOC)
that adds automatic HTTP request/response handling
it applies the Axios interceptor

 * How to use:
 * - Wrap any component that makes API calls with this HOC
 * - Example: export default withAxiosInterceptor(MyComponent);
* * - This will ensure that the Axios interceptor is applied to all API calls made within the component, will take care toasts and redirects if exits in response
 * */
const withAxiosInterceptor = <P extends object>(Component: React.ComponentType<P>) => {
  return (props: any) => {
    useAxiosInterceptor();
    return <Component {...props} />;
  };
};

export default withAxiosInterceptor;
